import { useAtom } from 'jotai';
import { saveStatusAtom } from '@/stores/saveStatus';
import { motion, AnimatePresence } from 'framer-motion';
import { Cloud, CloudOff, Check, Loader2 } from 'lucide-react';
import { useEffect } from 'react';

export function SaveIndicator() {
  const [status, setStatus] = useAtom(saveStatusAtom);

  // Auto-dismiss after 2s when saved
  useEffect(() => {
    if (status === 'saved') {
      const timer = setTimeout(() => {
        setStatus('idle');
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [status, setStatus]);

  const getIcon = () => {
    switch (status) {
      case 'saving':
        return <Loader2 className="w-4 h-4 animate-spin" />;
      case 'saved':
        return <Check className="w-4 h-4" />;
      case 'error':
        return <CloudOff className="w-4 h-4" />;
      default:
        return <Cloud className="w-4 h-4" />;
    }
  };

  const getText = () => {
    switch (status) {
      case 'saving':
        return 'Salvando...';
      case 'saved':
        return 'Salvo';
      case 'error':
        return 'Erro ao salvar';
      default:
        return '';
    }
  };

  const getColors = () => {
    switch (status) {
      case 'saving':
        return 'bg-muted text-muted-foreground';
      case 'saved':
        return 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400';
      case 'error':
        return 'bg-destructive/10 text-destructive';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  return (
    <AnimatePresence>
      {status !== 'idle' && (
        <motion.div
          initial={{ opacity: 0, y: 20, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.95 }}
          transition={{ type: 'spring', stiffness: 500, damping: 30 }}
          className="fixed bottom-6 right-6 z-50"
        >
          <div
            className={`flex items-center gap-2 px-4 py-2 rounded-full shadow-lg backdrop-blur-sm border border-border/50 ${getColors()}`}
          >
            {getIcon()}
            <span className="text-sm font-medium">{getText()}</span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
